<template>
  <v-card flat>
    <p style="text-align:left;margin:0;">
      <span class="primary white--text"
        style="padding:0px 5px;position:absolute;top:-10px;"
      >
        辛さ比較
      </span>
    </p>
    <h2 style="text-align:left;">
      {{rank.user.displayName}}さん
      <span style="font-size:80%;">の</span>
      <span class="primary--text" style="font-size:150%">{{focusPosition + 1}}</span>位！
    </h2>
    <v-list 
      style="border:solid 1px #ddd;border-radius:10px;"
    >
      <v-list-tile
        v-for="r in rankView"
        :key="r.id"
        avatar
        v-bind:class="{focus: r.isFocus, notFocus: !r.isFocus, }"
        :to="{name: 'searchFoodDetail', params: {id: r.id}}"
      >
        <v-list-tile-avatar>
          {{r.rank}}位
        </v-list-tile-avatar>

        <v-list-tile-avatar size=45>
          <img v-lazy="$options.filters.getImageUrl(r.id, r.images[0])">
        </v-list-tile-avatar>

        <v-list-tile-content>
          <v-list-tile-title v-text="r.name"
            style="padding-left:10px;font-weight:bold;"
          ></v-list-tile-title>
        </v-list-tile-content>
      </v-list-tile>
    </v-list>
    <v-btn flat color="primary"
      :to="{name: 'UserTop', params: {id: rank.user.uid}, query: {p: 'rank'}}"
    >
      辛さランキングをもっと見る
    </v-btn>
  </v-card>
</template>

<script>
import getImageUrl from '@/assets/js/getImageUrl.js'

export default {
  data () {
    return {
      rankView: []
    }
  },
  props: {
    rank: Object,
    focusPosition: Number
  },
  filters: {
    getImageUrl (id, fname) {
      return getImageUrl.get('food_thumbs', id, fname)
    }
  },
  created () {
    this.init()
  },
  methods: {
    init () {
      // 表示する食品の抽出
      let ini = this.focusPosition - 2
      if (ini < 0) {
        ini = 0
      }
      for (let i = ini; i < this.rank.foods.length; i++) {
        let obj = this.rank.foods[i]
        if (i === this.focusPosition) {
          obj.isFocus = true
        }
        this.rankView.push(obj)
        if (this.rankView.length >= 5) {
          break
        }
      }
    }
  }
}
</script>

<style scoped>
  .focus{
    background:#FFCDD2;
  }
  .focus div {
    font-weight: bold;
    font-size: 100%;
    color: #000
  }
  .notFocus div {
    color:#555;
  }
</style>
